module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_9016.8bf08f02.png";